<template>
    <Loading v-if="$store.state.is_loading" class="static" />
    <div class="home-content" v-else-if="page">
        <Hero v-if="page.hero_item" :data="page.hero_item" />

        <List>
            <header>
                <h2 v-html="page.our_products.title"></h2>
                <p>
                    <span v-html="page.our_products.text"></span> 
                    <Link v-if="page.our_products.link" :post_link="page.our_products.link" v-html="page.our_products.text_of_link" />
                </p>
            </header>
            <div class="cols">
                <Item class="col-3-1" v-for="item in products" :item="item" :key="item.ID" />
            </div>
        </List>

        <List>
            <header>
                <h2 v-html="page.test.title.replace('&#8232;', '')"></h2>
                <p>
                    <span v-html="page.test.text"></span> 
                    <Link v-if="page.test.link" :post_link="page.test.link" v-html="page.test.text_of_link" />
                </p>
            </header>
            <div class="cols">
                <Item class="col-3-1" v-for="item in page.test.items" :item="item" :key="item.ID" />
            </div>
        </List>

        <Section :left="page.our_approach.left" :center="page.our_approach.center" :right="page.our_approach.right" />
    </div>
</template>

<script>
import Loading from '@/components/ui/Loading.vue';
import Hero from '@/components/Hero.vue';
import List from '@/components/ui/List.vue';
import Item from '@/components/ui/Item.vue';
import Link from '@/components/ui/Link.vue';
import Section from '@/components/ui/Section.vue';
import GetPreviewUrl from '@/utils/GetPreviewUrl';

export default {
    name: 'HomeView',

    data () {
        return {
            page: false,
            products: [],
        }
    },

    components: {
        Loading,
        Hero,
        List,
        Item,
        Link,
        Section,
    },

    mounted() {
        document.title = window.globals.name + ' — ' + window.globals.description;
        this.$store.state.is_loading = true;

        this.page = false;
        const api_obj = GetPreviewUrl('pages', 'home-page');
        this.$ajax.get(api_obj.url, api_obj.head).then(res => {
            res.data[0].our_products.items.forEach(item => {
                this.products.push({
                    ID: item.category.term_id,
                    type: 'category',
                    featured_image: item.image.sizes,
                    post_title: item.category.name,
                    link: '/product-category/' + item.category.slug,
                    sub_title: item.sub_title,
                });
            });
            this.page = res.data[0];
            this.$store.state.is_loading = false;
        }).catch(error => {
            this.$router.replace('/page/404');
        });
    },
}
</script>
